<template>
  <div>
    <a-button type="primary" @click="showModal">Add Medical Data</a-button>
    <a-modal v-model="visible" title="Add a new medical data">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Add</a-button>
      </template>

      <a-form class="mb-4" :form="form">
        <div class="row">
          <div class="col-md-6">
            <a-form-item label="Height">
            <a-input
              placeholder="Height"
              v-decorator="[`medical_data_height`, {rules: [{ required: false, message: `Please input student's height!` }]}]"
            />
            </a-form-item>
          </div>

          <div class="col-md-6">
            <a-form-item label="Weight">
            <a-input
              placeholder="Weight"
              v-decorator="[`medical_data_weight`, {rules: [{ required: false, message: `Please input student's weight!` }]}]"
            />
            </a-form-item>
          </div>
          <div class="col-md-12">
            <a-form-item label="Test type">
            <a-input
              placeholder="Test type"
              v-decorator="[`medical_data_test_type`, {rules: [{ required: false, message: `Please input test type!` }]}]"
            />
            </a-form-item>
          </div>
          <div class="col-md-12">
            <a-form-item label="Test result">
            <a-input
              placeholder="Test result"
              v-decorator="[`medical_data_test_result`, {rules: [{ required: false, message: `Please input test result!` }]}]"
            />
            </a-form-item>
          </div>
          <div class="col-md-4">
            <a-form-item
              label="Recorder on"
            >
            <a-date-picker
              v-decorator="[
              `medical_data_recorded_on`,
              {rules: [{ required: true, message: 'Please input an recorded date' }], initialValue: moment()},
              ]"
              :format=dateFormat />
            </a-form-item>
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'AddMedicalHistory',
  props: ['studentId'],
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      dateFormat: 'DD-MM-YYYY',
    }
  },
  methods: {
    moment,
    showModal() {
      this.visible = true
    },

    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to add a new medical data!`,
            onOk: () => {
              this.$http
                .post(`/api/student/medicalhistory/${this.studentId}`, {
                  ...values,
                  medical_data_recorded_on: moment(values.medical_data_recorded_on).format('YYYY-MM-DD'),
                })
                .then(({ data }) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully added!',
                    description: `Medical data successfully added.`,
                  })
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
    },
  },
}
</script>
